import * as React from "react";
import { useRef } from "react";
import { WorkflowNode } from "../../types";
import TextArea from "@/components/TextArea";
import { FormGroup } from "../RightAsideHelpers";
import VariablePicker from "@/components/VariablePicker";
import VariableHelpCard from "@/components/VariableHelpCard";

interface Props {
  node: WorkflowNode;
  onUpdate: (node: Partial<WorkflowNode>) => void;
}

export default function SendMessageEditor({ node, onUpdate }: Props) {
  const textAreaRef = useRef<HTMLTextAreaElement>(null);

  function handleInsert(variable: string) {
    const el = textAreaRef.current;
    if (el) {
      const start = el.selectionStart ?? (node.text?.length || 0);
      const end = el.selectionEnd ?? start;
      const current = node.text || "";
      const newText =
        current.substring(0, start) + variable + current.substring(end);
      onUpdate({ text: newText });
      // Restore cursor position after the inserted variable
      requestAnimationFrame(() => {
        el.focus();
        const newPos = start + variable.length;
        el.setSelectionRange(newPos, newPos);
      });
    } else {
      onUpdate({ text: (node.text || "") + variable });
    }
  }

  return (
    <>
      <VariableHelpCard context="sendMessage" />
      <FormGroup label="Message">
        <div className="relative">
          <div className="absolute right-1 top-1 z-10">
            <VariablePicker onInsert={handleInsert} />
          </div>
          <TextArea
            ref={textAreaRef}
            value={node.text}
            onChange={(e) => onUpdate({ text: e.currentTarget.value })}
            className="pr-10"
          />
        </div>
      </FormGroup>
    </>
  );
}
